import * as Yup from 'yup';

export const userValidationSchema = Yup.object().shape({
  nombreCompleto: Yup.string()
    .required('El nombre completo es requerido')
    .min(3, 'El nombre completo debe tener al menos 3 caracteres')
    .max(50, 'El nombre completo no puede exceder los 50 caracteres'),
  usuario: Yup.string()
    .required('El nombre de usuario es requerido')
    .min(3, 'El nombre de usuario debe tener al menos 3 caracteres')
    .max(20, 'El nombre de usuario no puede exceder los 20 caracteres')
    .matches(/^[a-zA-Z0-9]+$/, 'El nombre de usuario solo puede contener letras y números'),
  email: Yup.string()
    .required('El correo electrónico es requerido')
    .email('Formato de correo electrónico inválido'),
  password: Yup.string().when('$isCreating', {
    is: true,
    then: () => Yup.string()
      .required('La contraseña es requerida')
      .min(8, 'La contraseña debe tener al menos 8 caracteres')
      .max(20, 'La contraseña no puede exceder los 20 caracteres'),
    otherwise: () => Yup.string().optional(),
  }),
  role: Yup.string()
    .required('El rol es requerido')
    .oneOf(['user', 'admin', 'userManagement'], 'Rol no válido'),
});

export const validateUserForm = async (userData, isCreating = false) => {
  try {
    await userValidationSchema.validate(userData, { abortEarly: false, context: { isCreating } });
    return {};
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      return errors;
    }
    throw error;
  }
};